'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasMethodOf = exports.hasMethodAt = exports.transformPropOf = exports.doProp = exports.transformProp = undefined;

var _propertyOf2 = require('lodash/propertyOf');

var _propertyOf3 = _interopRequireDefault(_propertyOf2);

var _property2 = require('lodash/property');

var _property3 = _interopRequireDefault(_property2);

var _isFunction2 = require('lodash/isFunction');

var _isFunction3 = _interopRequireDefault(_isFunction2);

var _flow2 = require('lodash/flow');

var _flow3 = _interopRequireDefault(_flow2);

var _curry2 = require('lodash/curry');

var _curry3 = _interopRequireDefault(_curry2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Return result of calling checker with object property.
var transformProp = exports.transformProp = (0, _curry3.default)(function (transformer, path) {
  return (0, _flow3.default)((0, _property3.default)(path), transformer);
});
var doProp = exports.doProp = transformProp;
var transformPropOf = exports.transformPropOf = (0, _curry3.default)(function (transformer, object) {
  return (0, _flow3.default)((0, _propertyOf3.default)(object), transformer);
});

// Check if property has a method at path. hasMethodAt(path)(object)
var hasMethodAt = exports.hasMethodAt = transformProp(_isFunction3.default);
var hasMethodOf = exports.hasMethodOf = transformPropOf(_isFunction3.default);


//////////////////
// WEBPACK FOOTER
// ./~/cape-lodash/lib/transform.js
// module id = 302
// module chunks = 0